import {
	Switch,
	useMantineColorScheme,
	rem,
	MantineColorScheme
} from "@mantine/core"
import { IconSun, IconMoon } from "@tabler/icons-react"
import { useEffect, useState } from "react"
import { StorageKeys } from "@utils/user-config"
import secureLocalStorage from "react-secure-storage"
import { eventTrackingItems } from "@utils/eventTracking"

export function ThemeSwitch({ ...props }) {
	const { colorScheme, setColorScheme } = useMantineColorScheme()
	const [isChecked, setIsChecked] = useState(false)

	useEffect(() => {
		const savedColorScheme = secureLocalStorage.getItem(
			StorageKeys.USER_PREFFERED_COLOR_SCHEME
		)
		if (savedColorScheme) {
			setColorScheme(savedColorScheme as MantineColorScheme)
		}
		setIsChecked(colorScheme === "dark")
	}, [])

	useEffect(() => {
		setIsChecked(colorScheme === "dark")
	}, [colorScheme])

	const handleChange = () => {
		const newColorScheme = colorScheme === "light" ? "dark" : "light"
		setColorScheme(newColorScheme)
		secureLocalStorage.setItem(
			StorageKeys.USER_PREFFERED_COLOR_SCHEME,
			newColorScheme
		)
		eventTrackingItems({
			event_name: "click",
			link_url: "",
			category: "click",
			interactionType: "mode_click",
			navLinkText: ""
		})
	}

	const sunIcon = (
		<IconSun
			id="sun-icon"
			data-test-id="sun-icon"
			size={rem(18)}
			stroke={1.5}
		/>
	)

	const moonIcon = (
		<IconMoon
			id="moon-icon"
			data-test-id="moon-icon"
			size={rem(18)}
			stroke={1.5}
		/>
	)

	return (
		<Switch
			id="theme-switch"
			h={"100%"}
			checked={isChecked}
			aria-label={
				colorScheme === "light" ? "Toggle dark mode" : "Toggle light mode"
			}
			onChange={handleChange}
			size="lg"
			onLabel={moonIcon}
			offLabel={sunIcon}
			color="var(--mantine-color-royal-17)"
			data-qa="header.button.lightdark"
			{...props}
		/>
	)
}
